<template>
    <b-navbar type="is-navbar-main navbar-default" class="app-navbar" is-active centered>
        <template #brand>
            <a class="navbar-item" id="icon-sidebar" title="Abrir o menu" :class="{ 'is-hidden': sidebarIsOpened }" @click="SET_SIDEBAR(true)">
                <b-icon icon="menu"></b-icon>
            </a>

            <a class="navbar-item app-navbar-brand is-hidden-mobile" title="Ir para o início" @click="$router.push(`/`)">
                <img v-if="config.logoBase64_2" :src="'data:image/png;base64, ' + config.logoBase64_2" alt="MyIndústria" />
                <img v-else src="../assets/logo.png" alt="MyIndústria" />
            </a>
        </template>

        <template #end>

            <div v-if="config.logoffTimer" class="navbar-item" id="navIdleProgressBar">
                <b-progress :value="idleProgressBarValue" :type="idleProgressBarType" show-value>
                    <small>{{ idleRemainingTime }}</small>
                </b-progress>
            </div>



            <a
                v-if="isInRole('prd-notificacoes-consultar')"
                class="navbar-link app-navbar-action is-arrowless"
                title="Notificações do UsiFlow"
                @click="abrirNotificacoes"
            >
                <b-icon icon="bell"></b-icon>
                <b-tag v-if="totalNotificacao > 0" type="is-danger tag-notify" rounded>{{ totalNotificacao }}</b-tag>
            </a>            

            <a class="navbar-link app-navbar-action is-arrowless" @click="TOGGLE_MODAL_USUARIO" title="Editar perfil">
                <b-icon icon="account"></b-icon>
            </a>

            <prd-notificacoes-modal
                v-if="isInRole('prd-notificacoes-consultar')"
                :active.sync="modalNotificacaoIsOpened"
                :unidade-id="unidadeId"
                @total-atualizado="atualizarTotalNotificacoes"
            />

            <b-modal :active="modalUsuarioIsOpened" @update:active="modalUsuarioIsOpened = $event" has-modal-card trap-focus aria-role="dialog" aria-modal>
                <modal-usuario @close="modalUsuarioIsOpened = false"></modal-usuario>
            </b-modal>
        </template>
    </b-navbar>
</template>

<style scoped>
    .app-navbar {
        position: fixed;
        z-index: 40;
        top: 0;
        right: 0;
        left: 0;
        min-height: 3.25rem;
        background: var(--surface-page);        
        box-shadow: 0 5px 18px rgba(16, 47, 76, 0.18);
    }

    .app-navbar-brand {
        padding-top: 0.35rem;
        padding-bottom: 0.35rem;
        cursor: pointer;
    }

    .app-navbar-brand img {
        width: auto;
        max-width: 150px;
        max-height: 2.25rem;
        object-fit: contain;
    }

    .app-navbar-action {
        min-width: 3.1rem;
        justify-content: center;
        color: rgba(255, 255, 255, 0.9);
    }

    .app-navbar-action:hover,
    .app-navbar-action:focus {
        background: rgba(255, 255, 255, 0.1) !important;
        color: white !important;
    }

    #icon-sidebar {
        color: white;
    }

    #navIdleProgressBar {
        color: white;
    }

    .dropdown-item-custom {
        padding: 0.75rem 1rem;
        border-bottom: 1px solid #e0e0e0;
    }

    .dropdown-item-custom:last-child {
        border-bottom: none;
    }

    .dropdown-item-custom:hover {
        background-color: #f5f5f5;
    }
</style>

<script>
    import { mapState, mapGetters } from 'vuex'
    import { mapMutations } from 'vuex'
    import http from '@/http'
    import modalUsuario from '@/components/modalUsuario'
    import prdNotificacoesModal from '@/components/prd/prdNotificacoesModal.vue'

    export default {
               
        components: {
            modalUsuario,
            prdNotificacoesModal
        },
        mounted() {
            this.loadTotalNotificacoesFuncionario();              
        },

        watch: {
            unidadeId() {
                this.carregarTotalNotificacoesPrd();
            },
            '$route.fullPath'() {
                this.carregarTotalNotificacoesPrd();
            }
        },

        computed: {
          
            idleRemainingTime() {
                const totalSeconds = (this.$store.state.config.logoffMiliseconds - this.$store.state.idle.time) / 1000;

                const minutes = Math.floor(totalSeconds / 60);
                const seconds = Math.floor(totalSeconds % 3600 % 60);

                return minutes + ":" +
                    (seconds < 10 ? "0" : "") + seconds;
            },
            idleProgressBarValue() {
                const value = ((this.$store.state.config.logoffMiliseconds - this.$store.state.idle.time) / this.$store.state.config.logoffMiliseconds) * 100;
                return isNaN(value)
                    ? 100
                    : value;
            },
            idleProgressBarType() {
                return this.idleProgressBarValue > 66
                    ? "is-info"
                    : this.idleProgressBarValue > 33
                        ? "is-warning"
                        : "is-danger";
            },
            notificationsCount() {
                return 10;
            },            

            modalNotificacaoIsOpened: {
                get() {
                    return this.$store.state.componentes.modalNotificacaoIsOpened;
                },
                set(value) {
                    return this.$store.commit('componentes/SET_MODAL_NOTIFICACAO', value)
                }
            },  
            totalNotificacao:{
                get() {
                    return this.$store.state.componentes.totalNotificacao;
                },
                set() {
                    return this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO',0)
                }                

            },         
            totalMensagens:{
                get() {
                    return this.$store.state.componentes.totalMensagens;
                },
                set() {
                    return this.$store.commit('componentes/SET_TOTAL_MENSAGENS',0)
                }                

            },             
            modalUsuarioIsOpened: {
                get() {
                    return this.$store.state.componentes.modalUsuarioIsOpened;
                },
                set(value) {
                    return this.$store.commit('componentes/SET_MODAL_USUARIO', value)
                }
            },
            ...mapState([
                'config',
                'usuario',
                'unidadeId'
            ]),
            ...mapGetters([
                'isInRole'
            ]),
            ...mapState('componentes', [
                'sidebarIsOpened'
            ])
        },
        methods: {
            loadTotalNotificacoesFuncionario() {
                this.carregarTotalNotificacoesPrd();

                http.get('/api/notificacao/RetornaTotalMensagensFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                            this.$store.commit('componentes/SET_TOTAL_MENSAGENS',data)
                        
                    })
                    .catch((error) => {                        
                        throw error
                    });                       
                
            },
            async carregarTotalNotificacoesPrd() {
                if (!this.unidadeId || !this.isInRole('prd-notificacoes-consultar')) {
                    this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO', 0);
                    return;
                }
                try {
                    const res = await http.get(`/api/prd/dashboard/notificacoes?unidadeId=${this.unidadeId}&somenteNaoLidas=true`);
                    this.atualizarTotalNotificacoes((res.data || []).length);
                } catch (error) {
                    this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO', 0);
                }
            },
            abrirNotificacoes() {
                this.modalNotificacaoIsOpened = true;
            },
            atualizarTotalNotificacoes(total) {
                this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO', total);
            },
            ...mapMutations('componentes', [
                'SET_SIDEBAR',
                'TOGGLE_MODAL_USUARIO',
                'SET_TOTAL_NOTIFICACAO',
                'SET_TOTAL_MENSAGENS'
            ]),
            redirectTo(page){
                this.$router.push({ name: page});
            }

        }
    }
</script>
